import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <>
            <section className="kbDoc-banner-support">
                <div className="banner-content text-center">
                    <div className="banner-content-wrapper">
                        <h1 className="banner-title wow fadeInUp">Benvenuto su legal di Psicopatici</h1>
                        <p className="banner-description wow fadeInUp" data-wow-delay="0.3s">
                           Consigliamo di consultare i nostri contratti legali prima di procedere ad utilizzare tutti i nostri servizi, ed acquistare i nostri prodotti.
                        </p>

                        {/* Aggiungiamo 'row' e 'justify-content-center' per gestire l'allineamento */}
                        <div className="communities-boxes row justify-content-center g-4 g-lg-4">
                            
                            {/* Box 1: col-6 (metà schermo su mobile), col-lg-4 (un terzo su desktop) */}
                            <div className="kbDoc-com-box col-6 col-lg-4 wow fadeInRight mb-0" data-wow-delay="0.5s">
                                <div className="kbDoc-com-box-content">
                                    <i className='fal fa-file-contract'></i>
                                    <h3 className="title">
                                        <Link to="/terms-and-conditions"> Termini & Condizioni</Link>
                                    </h3>
                                    <p className="total-post mb-2">Ultimo aggiornamento 1 settimana fa</p>
                                </div>
                            </div>

                            {/* Box 2 */}
                            <div className="kbDoc-com-box col-6 col-lg-4 wow fadeInRight mb-0" data-wow-delay="0.5s">
                                <div className="kbDoc-com-box-content">
                                    <i className='fal fa-file-contract'></i>
                                    <h3 className="title">
                                        <Link to="/partner-terms"> Termini & Condizioni Partner</Link>
                                    </h3>
                                    <p className="total-post mb-2">Ultimo aggiornamento 1 settimana fa</p>
                                </div>
                            </div>

                            {/* Box 3 */}
                            <div className="kbDoc-com-box col-6 col-lg-4 wow fadeInRight mb-0" data-wow-delay="0.5s">
                                <div className="kbDoc-com-box-content">
                                    <i className='fal fa-user-secret'></i>
                                    <h3 className="title">
                                        <Link to="/privacy-policy"> Privacy Policy</Link>
                                    </h3>
                                    <p className="total-post mb-2">Ultimo aggiornamento 1 settimana fa</p>
                                </div>
                            </div>

                            {/* Box 4: Su desktop va a capo da solo e si centra grazie a 'justify-content-center' */}
                            <div className="kbDoc-com-box col-6 col-lg-4 wow fadeInRight" data-wow-delay="0.5s">
                                <div className="kbDoc-com-box-content">
                                    <i className='fal fa-cookie'></i>
                                    <h3 className="title">
                                        <Link to="/cookie-policy"> Cookie Policy</Link>
                                    </h3>
                                    <p className="total-post mb-2">Ultimo aggiornamento 1 settimana fa</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;